import React from "react";

const SchemaNotFound = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <p>Something went wrong please contact us</p>
    </div>
  );
};

export default SchemaNotFound;
